export default async function publicAuth({ next, store }) {
  const token = await store.dispatch('fetchPublicAccessToken');
  if (!token) {
    return next({
      name: 'Invalid Token',
    });
  }
  return next();
}
